import React, { useRef } from 'react'
import { useEffect, useState } from "react";
import InputField from '../InputField'

import regExp from '../../constant/regExpressions';

import {
    getContactAction,
    updateContactAction,
    deleteContact,
    deleteContactImage
} from "../../actions/updateProfileAction";
import { connect } from "react-redux";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import errorMessages from "../../constant/errorMessages";
import { useParams } from "react-router-dom";
import { isEmpty, map, size, split } from 'lodash';
import { showErrorMessage, showSuccessMessage } from '../../utils/common';
import defaultValues from "../../constant/defaultValues";
import ButtonAdd from '../ButtonAdd';

import { hideLoading, showLoading } from "../../actions/loaderAction";
import MultiChoosefile from '../../components/MultiChoosefile';
import uploadPhotos from "../../images/Company-logo.svg";

import SmallPopup from "../../components/SmallPopup";
import ButtonAdminpanel from '../ButtonAdminpanel';
import MediumPopup from "../../components/MediumPopup";
import { useAuth } from '../../AuthProvider';

function ContectInfo(props) {

    const { IMAGE_PATH, IGNORE_EMAILS, EMAIL_FIELD_MAX_LENGTH } = defaultValues;
    const PATH = IMAGE_PATH.BASE_URL;

    const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 MB
    const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/jpg'];

    const { id } = useParams();
    const initialRef = useRef(true);

    const { isViewer } = useAuth();

    const [array, setArray] = useState([0]);
    const [errors, setErrors] = useState({});
    const [allErrors, setAllErrors] = useState({});

    const [isButtonDisabled, setisButtonDisabled] = useState(false);

    const [file, setFile] = useState({});
    const [formdata, setFormData] = useState({});
    const [existingFiles, setExistingFiles] = useState({});

    const [smallmodalShow, setSmallModalShow] = useState(false);
    const [deletecontactId, setDeleteContactId] = useState();

    const [deleteImageId, setDeleteImageId] = useState();
    const [smallmodalShow0, setSmallModalShow0] = useState(false);

    const [docImagePath, setDocImagePath] = useState();
    const [mediummodalShow, setMediumModalShow] = useState(false);

    const [oldImages, setOldImages] = useState({});
    const [currentInx, setCurrentInx] = useState({});
    const [inputFields, setInputFields] = useState([
        {
            salutation: "Mr",
            first_name: "",
            last_name: "",
            email: "",
            designation: "",
            phone: "",
            id: "",
            inq_allow: false
        },
    ]);

    const [inqOnRegEmail, setInqOnRegEmail] = useState(true);
    const [regEmail, setIsRegEmail] = useState(false);
    const [memberEmail, setMemberEmail] = useState(null);

    const handleAddDiv = (event) => {
        if (array.length) {
            setArray((prev) => [...prev, array.length]);
            setInputFields([
                ...inputFields,
                {
                    salutation: "Mr",
                    first_name: "",
                    last_name: "",
                    email: "",
                    designation: "",
                    phone: "",
                    id: "",
                    inq_allow: false
                },
            ]);

        }


        if (array.length > 0) {
            let err = { ...allErrors };

            const updatedErrors = Object.keys(err).reduce((acc, key) => {
                if (!key.includes(array.length)) {
                    acc[key] = err[key];
                }
                return acc;
            }, {});
            setAllErrors(updatedErrors);

            let error = { ...errors };

            const updatedError = Object.keys(error).reduce((acc, key) => {
                if (!key.includes(array.length)) {
                    acc[key] = err[key];
                }
                return acc;
            }, {});
            setErrors(updatedError);

        }

    };


    // const handleRemoveDiv = (idx) => {

    //     if (inputFields.length <= 3) {
    //         document.getElementById("addButton").style.display = "block";
    //     }
    //     if (inputFields.length > 1) {
    //         setArray((prev) => prev.filter((_, index) => index !== idx));
    //         setInputFields((prev) => prev.filter((_, index) => index !== idx));

    //         let err = { ...errors }
    //         const updatedError = Object.keys(errors).reduce((acc, key) => {
    //             if (!key.includes(idx)) {
    //                 acc[key] = err[key];
    //             }
    //             return acc;
    //         }, {});
    //         setErrors(updatedError);
    //     }

    // };

    const handleRemoveDiv = (idx) => {
        const currentKey = `images#@${idx}`;
        revokeBlobURL(existingFiles, currentKey);
        revokeBlobURL(file, currentKey);
        if (existingFiles[currentKey]?.path?.startsWith("blob:")) {
            URL.revokeObjectURL(existingFiles[currentKey].path);
        }

        const updatedFields = inputFields.filter((_, index) => index !== idx);
        setInputFields(updatedFields);


        const rebuildState = (prevObj) => {
            const newObj = {};
            updatedFields.forEach((_, newIdx) => {
                const oldKey = `images#@${newIdx >= idx ? newIdx + 1 : newIdx}`;
                const newKey = `images#@${newIdx}`;
                if (prevObj[oldKey]) {
                    newObj[newKey] = prevObj[oldKey];
                }
            });
            return newObj;
        };

        setFile(prev => rebuildState(prev));
        setFormData(prev => rebuildState(prev));
        setExistingFiles(prev => rebuildState(prev));

        let err = { ...errors }
        const updatedError = Object.keys(errors).reduce((acc, key) => {
            if (!key.includes(idx)) {
                acc[key] = err[key];
            }
            return acc;
        }, {});
        setErrors(updatedError);

    };


    const handleContactInfoChange = (e, idx) => {
        const { name, value } = e.target;
        const newInputFields = [...inputFields];
        newInputFields[idx][name] = value;

        if(name === "email") {
            if(isEmpty(value)) {
                newInputFields[idx].inq_allow = false;
            }
            
        }
        setInputFields(newInputFields);
    };

    const handleContactPhoneChange = (val, idx) => {
        const newInputFields = [...inputFields];
        newInputFields[idx].phone = val;
        setInputFields(newInputFields);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validation()) {
            props.showLoading();
            if (checkAllInputsEmpty()) {
                // console.log("STATUS ===", checkAllInputsEmpty());
                // showErrorMessage("Please Fill up required fields");
            } else {
                await props
                    .updateContact(
                        id,
                        inputFields,
                        formdata,
                        "normal",
                        inqOnRegEmail
                    )
                    .then((response) => {
                        let newErrors = {};
                        let newErrors2 = {};
                        if (response === true) {
                            setErrors({});
                            setAllErrors({});
                            showSuccessMessage("Update profile successfully...");
                            setTimeout(async () => {
                                //  props.showLoading();
                                await fetchContactInfo();
                                props.hideLoading();
                            }, 2000);

                        }
                        if (response.status === false) {

                            if (response.error) {
                                const result = Object.entries(response.error);
                                result.forEach(([key, value]) => {
                                    if (key.endsWith('email') && value === 'The field is required') {
                                        newErrors[key] = errorMessages.BOTH_EMAIL_OR_PHONE;
                                    }
                                    else if (key.endsWith('phone') && value === 'The field is required') {
                                        newErrors[key] = '';
                                    } else {
                                        //newErrors[key] = value;
                                        if (key) {
                                            let nKey = split(key, '.');
                                            if (nKey[1] != undefined && nKey[1] != null) {
                                                if (nKey[1] === 'image') {
                                                    let iKey = `images#@${nKey[0]}`;
                                                    newErrors[iKey] = value;
                                                } else {
                                                    newErrors[`${nKey[1]}${nKey[0]}`] = value;
                                                }
                                            }

                                        }
                                    }
                                });
                                // setErrors(newErrors); 
                            }

                            if (response.error.errorMsg) {
                                const result1 = Object.entries(response.error.errorMsg);
                                result1.forEach(([key, value]) => {
                                    const cleanedKey = key.replace('.', '');
                                    newErrors2[cleanedKey] = Array.isArray(value) ? value[0] : value;
                                });
                            }
                            let allError = { ...newErrors, ...newErrors2 };
                            setErrors(allError);
                        }

                    })
                    .catch((error) => {
                        console.log(error);
                        showErrorMessage("Something went wrong");
                    });
            }
            props.hideLoading();
        }
    }

    const checkAllInputsEmpty = () => {
        setErrors({});
        const newErrors = {};
        let objValues = [];
        let objectValues2 = [];
        let tmpInputs = [...inputFields];
        tmpInputs.forEach((field, idx) => {
            let { salutation, ...tmpfield } = field;

            objValues[idx] = Object.values(tmpfield);
            if (!isEmpty(objValues[idx].filter(n => n))) {
                objectValues2.push(idx + 1);
            }
        });

        if (isEmpty(objectValues2) === true) {
            tmpInputs.forEach((field, idx) => {
                newErrors[`first_name${idx}`] = errorMessages.FIELD_REQUIRED;
                newErrors[`phone_and_email${idx}`] = errorMessages.BOTH_EMAIL_OR_PHONE;
            });

            setAllErrors(newErrors);
        }
        return isEmpty(objectValues2);
    }

    const validation = () => {
        setAllErrors({});
        const newErrors = {};
        let hasError = false;
        // const regExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        inputFields.forEach((field, idx) => {
            if (field.first_name !== '') {

                const regExpression = regExp.name;
                const isValid = regExpression.test(field.first_name);

                if (!isValid) {
                    newErrors[`first_name${idx}`] = errorMessages.IN_VALID_FIELD_FORMAT;
                    hasError = true;
                } else if (size(field.first_name) > 20) {
                    newErrors[`first_name${idx}`] = errorMessages.MAX_CHARACTERS_REACHED;
                    hasError = true;
                }

                if (field.email === '' && field.phone === '') {
                    // newErrors[`email${idx}`] = errorMessages.FIELD_REQUIRED;
                    // newErrors[`phone${idx}`] = errorMessages.FIELD_REQUIRED;
                    newErrors[`email${idx}`] = errorMessages.BOTH_EMAIL_OR_PHONE;
                    hasError = true;
                }
            }
            if (field.email !== '' && field.email !== null) {
                newErrors[`email${idx}`] = '';
                if ((field.first_name === '')) {
                    newErrors[`first_name${idx}`] = errorMessages.FIELD_REQUIRED;
                    hasError = true;
                }
                if (field.email.length > EMAIL_FIELD_MAX_LENGTH) {
                    newErrors[`email${idx}`] = errorMessages.MAX_LENGTH_150_EXCEEDED;
                    hasError = true;
                }
                const currentEmail = field.email.split('@')[1];
                const regExpEmail = regExp.email;
                const isValid = regExpEmail.test(field.email);

                if (!isValid || IGNORE_EMAILS.includes(currentEmail)) {
                    newErrors[`email${idx}`] = errorMessages.IN_VALID_FIELD_FORMAT;
                    hasError = true;
                }

            }
            if (field.phone !== '' && field.phone !== null && field.phone !== undefined) {
                newErrors[`phone${idx}`] = '';
                if ((field.first_name === '') || (field.phone === null)) {
                    newErrors[`first_name${idx}`] = errorMessages.FIELD_REQUIRED;
                    hasError = true;
                }
            }
            if (field.phone) {
                let mobileValue = field.phone;
                if (mobileValue.length > 0) {
                    if (!field.phone || !isValidPhoneNumber(field.phone)) {
                        newErrors[`phone${idx}`] = errorMessages.MOBILE_NUMBER_VALIDATION_MSG;
                        hasError = true;
                    }
                }


            }

            if (field.designation) {
                const regExpression = regExp.designation;
                const isValid = regExpression.test(field.designation);

                if (!isValid) {
                    newErrors[`designation${idx}`] = errorMessages.IN_VALID_FIELD_FORMAT;
                    hasError = true;
                } else if (size(field.designation) > 100) {
                    newErrors[`designation${idx}`] = errorMessages.MAX_CHARACTERS_REACHED;
                    hasError = true;
                }
            }

            if (field.last_name) {
                const regExpression = regExp.name;
                const isValid = regExpression.test(field.last_name);

                if (!isValid) {
                    newErrors[`last_name${idx}`] = errorMessages.IN_VALID_FIELD_FORMAT;
                    hasError = true;
                } else if (size(field.last_name) > 20) {
                    newErrors[`last_name${idx}`] = errorMessages.MAX_CHARACTERS_REACHED;
                    hasError = true;
                }
            }

            if (field.last_name !== '' || field.designation !== '') {
                if (field.email === '' && field.phone === '') {
                    // newErrors[`email${idx}`] = errorMessages.FIELD_REQUIRED;
                    // newErrors[`phone${idx}`] = errorMessages.FIELD_REQUIRED;
                    newErrors[`email${idx}`] = errorMessages.BOTH_EMAIL_OR_PHONE;
                    hasError = true;
                }
                if (field.first_name === '') {
                    newErrors[`first_name${idx}`] = errorMessages.FIELD_REQUIRED;
                    hasError = true;
                }
            }

            // if (idx > 0) {
            if ((field.email === '' || field.email === null || field.email === undefined) && (field.phone === '' || field.phone === null || field.phone === undefined)) {
                // newErrors[`email${idx}`] = errorMessages.FIELD_REQUIRED;
                // newErrors[`phone${idx}`] = errorMessages.FIELD_REQUIRED;
                newErrors[`email${idx}`] = errorMessages.BOTH_EMAIL_OR_PHONE;
                hasError = true;
            }

            if (field.first_name === '') {
                newErrors[`first_name${idx}`] = errorMessages.FIELD_REQUIRED;
                hasError = true;
            }
            // }

        });

        setErrors(newErrors);
        return !hasError;
    };

    const handleFocusOut = (e, idx) => {
        setAllErrors({});
        const { name, value } = e.target;
        let hasError = false;

        if (name === "first_name") {
            if (value !== '') {
                const regExpName = regExp.name;
                const isValid = regExpName.test(value);

                if (!isValid) {
                    hasError = true;
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        [`first_name${idx}`]: errorMessages.IN_VALID_FIELD_FORMAT,
                    }));
                } else if (size(value) > 20) {
                    hasError = true;
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        [`first_name${idx}`]: errorMessages.MAX_CHARACTERS_REACHED,
                    }));
                } else {
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        [`first_name${idx}`]: '',
                    }));
                }
            } else {
                if (value.length === 0 && value === '') {
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        [`first_name${idx}`]: '',
                    }));
                }
                if (value.length > 0) {
                    hasError = true;
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        [`first_name${idx}`]: errorMessages.FIELD_REQUIRED,
                    }));
                }
            }
        }

        if (name === "last_name") {
            const regExpName = regExp.name;
            const isValid = regExpName.test(value);

            if (value.length > 0 && !isValid) {
                hasError = true;
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [`last_name${idx}`]: errorMessages.IN_VALID_FIELD_FORMAT,
                }));
            } else if (value.length > 0 && size(value) > 20) {
                hasError = true;
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [`last_name${idx}`]: errorMessages.MAX_CHARACTERS_REACHED,
                }));
            } else {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [`last_name${idx}`]: '',
                }));
            }
        }

        if (name === "email") {

            const currentEmail = value.split('@')[1];
            // const regExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            const regExpEmail = regExp.email;
            const isValid = regExpEmail.test(value);
            const isDuplicateEmail = inputFields.some((item, index) => item.email === value && index !== idx);

            if ((value.length > 0) && (!isValid || IGNORE_EMAILS.includes(currentEmail))) {

                hasError = true;
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [`email${idx}`]: errorMessages.IN_VALID_FIELD_FORMAT,
                }));
            } else if (value.length > 0 && isDuplicateEmail) {
                hasError = true;
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [`email${idx}`]: errorMessages.UNIQUE_MSG,
                }));
            } else if (size(value) > EMAIL_FIELD_MAX_LENGTH) {
                hasError = true;
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [`email${idx}`]: errorMessages.MAX_LENGTH_150_EXCEEDED,
                }));
            } else {
                // if (value.length > 0 && !isDuplicateEmail) {
                //     setErrors((prevErrors) => {
                //         let updatedErrors = { ...prevErrors };
                //         Object.keys(updatedErrors).forEach((key) => {
                //             if (key.startsWith('email')) {
                //                 updatedErrors[key] = '';
                //             }
                //         });
                //         return updatedErrors;
                //     });
                // } else {
                //     setErrors((prevErrors) => ({
                //         ...prevErrors,
                //         [`email${idx}`]: '',
                //     }));
                // }
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [`email${idx}`]: '',
                }));
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [`phone${idx}`]: '',
                }));
            }

        }

        if (name === "designation") {
            const designationReg = regExp.designation;
            const isValid = designationReg.test(value);

            if (value.length > 0 && !isValid) {
                hasError = true;
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [`designation${idx}`]: errorMessages.IN_VALID_FIELD_FORMAT,
                }));
            } else if (value.length > 0 && size(value) > 100) {
                hasError = true;
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [`designation${idx}`]: errorMessages.MAX_CHARACTERS_REACHED,
                }));
            } else {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [`designation${idx}`]: '',
                }));
            }
        }

        // if (name === 'phone') {
        //     // let mobileValue = value;
        //     // if (mobileValue) {
        //     //     if (!mobileValue || !isValidPhoneNumber(mobileValue)) {
        //     //         hasError = true;
        //     //         setErrors((prevErrors) => ({
        //     //             ...prevErrors,
        //     //             [`phone${idx}`]: errorMessages.IN_VALID_FIELD_FORMAT,
        //     //         }));
        //     //     } else {
        //     //         setErrors((prevErrors) => ({
        //     //             ...prevErrors,
        //     //             [`phone${idx}`]: '',
        //     //         }));
        //     //         setErrors((prevErrors) => ({
        //     //             ...prevErrors,
        //     //             [`email${idx}`]: '',
        //     //         }));
        //     //     }
        //     // }

        //     const normalizePhone = (phone) => phone.replace(/\D/g, '');
        //     const isDuplicatePhone = inputFields.some((item, index) => {
        //         return normalizePhone(item.phone) === normalizePhone(value) && index !== idx;
        //     });

        //     if (value.length > 0 && isDuplicatePhone) {
        //         hasError = true;
        //         setErrors((prevErrors) => ({
        //             ...prevErrors,
        //             [`phone${idx}`]: errorMessages.UNIQUE_MSG,
        //         }));
        //     } else {
        //         if (value.length > 0 && !isDuplicatePhone) {
        //             setErrors((prevErrors) => {
        //                 let updatedErrors = { ...prevErrors };
        //                 Object.keys(updatedErrors).forEach((key) => {
        //                     if (key.startsWith('phone')) {
        //                         updatedErrors[key] = '';
        //                     }
        //                 });
        //                 return updatedErrors;
        //             });
        //         }

        //     }
        // }
        if (name === 'phone') {

            const normalizePhone = (phone) => {
                if (phone && typeof phone === 'string') {
                    return phone.replace(/\D/g, '');
                }
                return '';
            };

            const isDuplicatePhone = inputFields.some((item, index) => {

                const itemPhone = item.phone ? normalizePhone(item.phone) : '';
                return itemPhone === normalizePhone(value) && index !== idx;
            });

            if (value && value.length > 0 && value != "+" && isDuplicatePhone) {
                hasError = true;
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [`phone${idx}`]: errorMessages.UNIQUE_MSG,
                }));
            } else {
                if (value && value.length > 0 && !isDuplicatePhone) {
                    setErrors((prevErrors) => {
                        let updatedErrors = { ...prevErrors };
                        Object.keys(updatedErrors).forEach((key) => {
                            if (key.startsWith('phone')) {
                                updatedErrors[key] = '';
                            }
                        });
                        return updatedErrors;
                    });
                }
            }
        }

        setisButtonDisabled(hasError);
        return hasError;
    };

    const styleError = {
        display: 'block',
    };

    // const handleChange2 = (e) => {


    //     const { name, files } = e.target;
    //     const [type, id] = name.split("#@");

    //     let error = '';

    //     if (files.length > 0) {
    //         const file = files[0];

    //         if (!ALLOWED_TYPES.includes(file.type)) {
    //             error = "The file must be a file of type jpg, png, jpeg";
    //         } else if (file.size > MAX_FILE_SIZE) {
    //             error = "The file must be less than or equal to 2 MB";
    //         }
    //     }

    //     if (error) {
    //         setErrors((prev) => ({
    //             ...prev,
    //             [name]: error,
    //         }));
    //         setFormData((prev) => ({
    //             ...prev,
    //             [name]: null,
    //         }));
    //         setFile((prev) => ({
    //             ...prev,
    //             [`images#@${id}`]: {
    //                 path: uploadPhotos,
    //                 file: null,
    //             },
    //         }));

    //         setExistingFiles((prev) => ({
    //             ...prev,
    //             [`images#@${id}`]: {
    //                 path: uploadPhotos,
    //                 file: null,
    //             },
    //         }));

    //         e.target.value = '';
    //     } else {
    //         setErrors((prev) => ({
    //             ...prev,
    //             [name]: undefined,
    //         }));
    //          console.log("last 111111111");
    //         if (files.length > 0) {
    //             setFormData((prev) => ({
    //                 ...prev,
    //                 [name]: files[0],
    //             }));
    //             setFile((prev) => ({
    //                 ...prev,
    //                 [`images#@${id}`]: {
    //                     path: URL.createObjectURL(files[0]),
    //                     file: files[0],
    //                 },
    //             }));
    //             setExistingFiles((prev) => ({
    //                 ...prev,
    //                 [`images#@${id}`]: {
    //                     path: URL.createObjectURL(files[0]),
    //                     file: files[0],
    //                 },

    //             }));
    //         } else {

    //             const imageFromOldImages = oldImages?.[id]?.image || null;
    //             setFormData((prev) => ({
    //                 ...prev,
    //                 [name]: null,
    //             }));

    //             setFile((prev) => ({
    //                 ...prev,
    //                 [`images#@${id}`]: {
    //                      path: PATH + '/member_contacts/' + imageFromOldImages  || uploadPhotos,
    //                      file: null,
    //                 },
    //             }));

    //             setExistingFiles((prev) => ({
    //                 ...prev,
    //                 [`images#@${id}`]: {
    //                    path: PATH + '/member_contacts/' + imageFromOldImages  || uploadPhotos,
    //                    imageId: oldImages?.[id]?.id,
    //                 },
    //             }));
    //         }

    //     }
    //     const hasErrors = Object.values({ ...errors, [name]: error }).some(err => err);
    //     setisButtonDisabled(hasErrors);

    // };
    //     const handleChange2 = (e) => {
    //   const { name, files } = e.target;
    //   const [type, id] = name.split("#@");

    //   let error = '';
    //   let newFile = null;
    //   let previewURL = '';

    //   if (files.length > 0) {
    //     newFile = files[0];

    //     // Validate type and size
    //     if (!ALLOWED_TYPES.includes(newFile.type)) {
    //       error = "The file must be a file of type jpg, png, jpeg";
    //     } else if (newFile.size > MAX_FILE_SIZE) {
    //       error = "The file must be less than or equal to 2 MB";
    //     }
    //   }

    //   // If validation error
    //   if (error) {
    //     setErrors((prev) => ({ ...prev, [name]: error }));
    //     setFormData((prev) => ({ ...prev, [name]: null }));
    //     setFile((prev) => ({
    //       ...prev,
    //       [name]: { path: uploadPhotos, file: null }
    //     }));
    //     setExistingFiles((prev) => ({
    //       ...prev,
    //       [name]: { path: uploadPhotos, file: null }
    //     }));

    //     e.target.value = ''; // Clear file input
    //   } else {
    //     // VALID FILE SELECTED
    //     if (newFile) {
    //       // First revoke old URL (if any)
    //       const oldPath = existingFiles[name]?.path;
    //       if (oldPath?.startsWith("blob:")) {
    //         URL.revokeObjectURL(oldPath);
    //       }

    //       previewURL = URL.createObjectURL(newFile);

    //       setErrors((prev) => ({ ...prev, [name]: undefined }));
    //       setFormData((prev) => ({ ...prev, [name]: newFile }));
    //       setFile((prev) => ({
    //         ...prev,
    //         [name]: { path: previewURL, file: newFile }
    //       }));
    //       setExistingFiles((prev) => ({
    //         ...prev,
    //         [name]: { path: previewURL, file: newFile }
    //       }));
    //     } else {
    //       // No file selected — use fallback image
    //       const imageFromOldImages = oldImages?.[id]?.image || null;
    //       const fallbackPath = imageFromOldImages
    //         ? `${PATH}/member_contacts/${imageFromOldImages}`
    //         : uploadPhotos;

    //       setFormData((prev) => ({ ...prev, [name]: null }));
    //       setFile((prev) => ({
    //         ...prev,
    //         [name]: { path: fallbackPath, file: null }
    //       }));
    //       setExistingFiles((prev) => ({
    //         ...prev,
    //         [name]: { path: fallbackPath, imageId: oldImages?.[id]?.id }
    //       }));
    //     }
    //   }

    //   // Recheck errors
    //   const hasErrors = Object.values({ ...errors, [name]: error }).some(Boolean);
    //   setisButtonDisabled(hasErrors);
    // };

    const handleChange2 = (e) => {
        const { name, files } = e.target;
        const [type, id] = name.split("#@");

        let error = '';
        const newFile = files[0];
        const oldPath = existingFiles[name]?.path;

        // Revoke old preview URL if needed
        if (oldPath?.startsWith("blob:")) {
            URL.revokeObjectURL(oldPath);
        }

        if (newFile) {
            // Validate file type and size
            if (!ALLOWED_TYPES.includes(newFile.type)) {
                error = "The file must be a file of type jpg, png, jpeg";
            } else if (newFile.size > MAX_FILE_SIZE) {
                error = "The file must be less than or equal to 2 MB";
            }

            if (error) {
                // Error: reset state and input
                setErrors((prev) => ({ ...prev, [name]: error }));
                setFormData((prev) => ({ ...prev, [name]: null }));
                setFile((prev) => ({
                    ...prev,
                    [name]: { path: uploadPhotos, file: null }
                }));
                setExistingFiles((prev) => ({
                    ...prev,
                    [name]: { path: uploadPhotos, file: null }
                }));

                // Reset input field (visually and logically)
                if (e.target) {
                    e.target.value = '';
                }

            } else {

                // Success: store file and preview URL
                const previewURL = URL.createObjectURL(newFile);

                setErrors((prev) => ({ ...prev, [name]: undefined }));
                setFormData((prev) => ({ ...prev, [name]: newFile }));
                setFile((prev) => ({
                    ...prev,
                    [name]: { path: previewURL, file: newFile }
                }));
                setExistingFiles((prev) => ({
                    ...prev,
                    [name]: { path: previewURL, file: newFile }
                }));
            }
        } else {

            // No file selected (e.g. cancel dialog) — fallback handling
            const fallbackImage = oldImages?.[id]?.image || null;
            const fallbackPath = fallbackImage
                ? `${PATH}/member_contacts/${fallbackImage}`
                : uploadPhotos;

            setErrors((prev) => ({ ...prev, [name]: undefined }));
            setFormData((prev) => ({ ...prev, [name]: null }));
            setFile((prev) => ({
                ...prev,
                [name]: { path: fallbackPath, file: null }
            }));
            setExistingFiles((prev) => ({
                ...prev,
                [name]: {
                    path: fallbackPath,
                    imageId: oldImages?.[id]?.id
                }
            }));
        }

        // Re-check button state after error handling
        const newErrors = { ...errors, [name]: error };
        const hasErrors = Object.values(newErrors).some(Boolean);
        setisButtonDisabled(hasErrors);
    };



    const handleRemoveDivImage = (id, inx) => {
        setSmallModalShow(true);
        setDeleteContactId(id);
        setCurrentInx(inx)
    }

    const revokeBlobURL = (obj, key) => {
        if (obj[key]?.path && obj[key].path.startsWith("blob:")) {
            URL.revokeObjectURL(obj[key].path);
        }
    };

    const handleConfirmDeleteClick = async () => {
        await props
            .deleteContact(deletecontactId)
            .then((response) => {
                setSmallModalShow(false);
                if (response.status === true) {

                    showSuccessMessage("Deleted successfully...");
                    setTimeout(async () => {
                        await fetchContactInfo();
                        props.hideLoading();

                    }, 0);
                }

            })
            .catch((err) => {
                console.log("Error == ", err);
                showErrorMessage("Something went wrong");
            });
    };

    const handleRemove = (id) => {
        setSmallModalShow0(true);
        setDeleteImageId(id);
    }

    const handleConfirmDeleteClick0 = async () => {
        await props
            .deleteContactImage(deleteImageId)
            .then((response) => {
                setSmallModalShow0(false);
                if (response.status === true) {
                    //setVErrors2({});
                    //  props.hideLoading();
                    showSuccessMessage("Deleted successfully...");
                    setTimeout(async () => {
                        await fetchContactInfo();
                        props.hideLoading();

                    }, 0);
                }

            })
            .catch((err) => {
                console.log("Error == ", err);
                showErrorMessage("Something went wrong");
            });
    };

    const handleImageShow = (path) => {
        setDocImagePath(path);
        setMediumModalShow(true);
    }

    const handleRegEmailChange = (e) => {
        const { checked } = e.target;
        setInqOnRegEmail(checked);
    }

    const handleContactInqEmail = (e, idx) => {
        const { checked } = e.target;
        const newInputFields = [...inputFields];
        newInputFields[idx].inq_allow = checked;
        setInputFields(newInputFields);
    }

    const fetchContactInfo = async () => {
        await props
            .getContact(id)
            .then((response) => {
                // setTimeout(() => {
                //     if (!isEmpty(response)) {
                //         setInputFields(response)
                //     }

                // }, 3000);
                setInqOnRegEmail(response.inqOnRegEmail);
                setMemberEmail(response.regEmail);

                if (!isEmpty(response.member_contacts)) {
                    setInputFields(response.member_contacts);
                    const existingFilesMap = {};

                    response.member_contacts.forEach((cert, i) => {
                        if (cert.image) {
                            existingFilesMap[`images#@${i}`] = {
                                path: PATH + '/member_contacts/' + cert.image,
                                imageId: cert.id,
                            };
                            setOldImages(response.member_contacts);
                        } else {
                            existingFilesMap[`images#@${i}`] = {
                                path: uploadPhotos,
                                imageId: cert.id,
                            };
                        }
                        setFormData((prev) => ({
                            ...prev,
                            [`images#@${i}`]: cert.image || null,
                        }));
                    });
                    setExistingFiles(existingFilesMap);
                }
            })
            .catch((error) => {
                console.log(error);
                showErrorMessage("Something went wrong");
            });
    };

    useEffect(() => {
        let flag = 0;
        map(inputFields, (val) => {
            if(val.inq_allow) {
                flag = 1;
            }
        });

        if(flag === 0) {
            setInqOnRegEmail(true);
            setIsRegEmail(true);
        } else {
            setIsRegEmail(false);
        }
    },[inqOnRegEmail, inputFields]);

    useEffect(() => {
        if (initialRef.current === true) {
            initialRef.current = false;
            fetchContactInfo();
        }

    }, []);

    const style3 = {
        height: '100%',
        width: '100%',
    };

    return (
        <>
            <form onSubmit={handleSubmit}>
                <h3 className='company-info-text'>Contact Info</h3>

                <div className='p-4 card-shadow bg-white rounded'>

                    {/* ****contect-person 1**** */}

                    <div>

                        <div className='d-flex justify-content-between align-items-center border-bottom pb-2'>
                            <h4 className='head-office-text'>Staff Person</h4>

                            {(!props.disableProfile && !isViewer) && (
                                <ButtonAdd className='add-btn' type='button' onClick={handleAddDiv} id='addButton' disabled={props.disableProfile || isViewer}>
                                    <i className="fa-solid fa-circle-plus mx-1"></i>
                                    <b>Add</b></ButtonAdd>
                            )}
                            {/* <ButtonAdd className='add-btn' type='button' onClick={handleAddDiv} id='addButton' disabled={props.disableProfile}>
                            <i className="fa-solid fa-circle-plus mx-1"></i>
                            <b>Add</b></ButtonAdd> */}



                        </div>

                        {inputFields.map((item, idx) => (
                            <div key={idx} id={idx}>

                                {idx !== 0 && (

                                    <div className='text-end mx-2 d-flex justify-content-between align-item-center border-bottom mt-4 pb-2'>
                                        <h4 className='head-office-text'>Staff Person {idx}</h4>
                                        {(!props.disableProfile && !isViewer) && (
                                            existingFiles[`images#@${idx}`]?.imageId ? (
                                                <ButtonAdd
                                                    className="btn-remove"
                                                    type="button"
                                                    onClick={() => handleRemoveDivImage(existingFiles[`images#@${idx}`]?.imageId, idx)}
                                                    disabled={props.disableProfile || isViewer}
                                                >
                                                    <i className="fa-solid fa-circle-minus mx-1"></i>
                                                    <b>Remove</b>
                                                </ButtonAdd>
                                            ) : (
                                                <ButtonAdd
                                                    className="btn-remove"
                                                    type="button"
                                                    onClick={() => handleRemoveDiv(idx)}
                                                    disabled={props.disableProfile || isViewer}
                                                >
                                                    <i className="fa-solid fa-circle-minus mx-1"></i>
                                                    <b>Remove</b>
                                                </ButtonAdd>
                                            )
                                        )
                                        }
                                        {/* <ButtonAdd className='btn-remove ' type='button' onClick={() => handleRemoveDiv(idx)} disabled={props.disableProfile}>
                                        <i className="fa-solid fa-circle-minus mx-1"></i>
                                        <b>Remove</b>
                                    </ButtonAdd> */}

                                    </div>
                                )}

                                <div className='row pt-3 contact-info-wrapper'>

                                    <div className='col-xxl-4 col-xl-6 py-3'>

                                        <label className='profile-text'>First Name
                                            <span className='text-danger'> *</span>
                                        </label>

                                        <div className='d-flex'>

                                            <span className={`input-group-addon ${(props.disableProfile || isViewer) ? `input-group-disable` : ``}`} >
                                                <select name="salutation" onChange={(e) => handleContactInfoChange(e, idx)} value={item.salutation} disabled={props.disableProfile || isViewer}
                                                    className={`${(props.disableProfile || isViewer) ? `input-group-disable` : ``}`}
                                                >
                                                    <option value="Mr">Mr</option>
                                                    <option value="Mrs">Mrs</option>
                                                    <option value="Miss">Miss</option>
                                                </select>
                                            </span>

                                            <div className='w-100'>
                                                <InputField
                                                    name="first_name"
                                                    placeholder={"Enter your first name"}
                                                    className={"input-error-border mr-input"}
                                                    value={item.first_name}
                                                    onChange={(e) => handleContactInfoChange(e, idx)}
                                                    onBlur={(e) => handleFocusOut(e, idx)}
                                                    disabled={props.disableProfile || isViewer}
                                                    maxLength={20 + 1}
                                                    autoComplete="off"
                                                />

                                            </div>

                                        </div>

                                        {errors[`first_name${idx}`] && (<span className="company-required-content" style={styleError}>
                                            {errors[`first_name${idx}`]}
                                        </span>
                                        )}
                                        {allErrors[`first_name${idx}`] && (<span className="company-required-content" style={styleError}>
                                            {allErrors[`first_name${idx}`]}
                                        </span>
                                        )}

                                    </div>

                                    <div className='col-xxl-4 col-xl-6 py-3'>
                                        <label className='profile-text'>Last Name
                                        </label>
                                        <InputField
                                            name="last_name"
                                            placeholder={"Enter your last name"}
                                            className={"input-error-border"}
                                            value={item.last_name}
                                            onChange={(e) => handleContactInfoChange(e, idx)}
                                            onBlur={(e) => handleFocusOut(e, idx)}
                                            disabled={props.disableProfile || isViewer}
                                            maxLength={20 + 1}
                                            autoComplete="off"
                                        />
                                        {errors[`last_name${idx}`] && (<span className="company-required-content" style={styleError}>
                                            {errors[`last_name${idx}`]}
                                        </span>
                                        )}

                                    </div>

                                    <div className='col-xxl-4 col-xl-6 py-3'>
                                        <label className='profile-text'>Designation
                                        </label>
                                        <InputField
                                            name="designation"
                                            placeholder={"Enter your designation"}
                                            className={"input-error-border"}
                                            value={item.designation}
                                            onChange={(e) => handleContactInfoChange(e, idx)}
                                            onBlur={(e) => handleFocusOut(e, idx)}
                                            disabled={props.disableProfile || isViewer}
                                            maxLength={100 + 1}
                                            autoComplete="off"
                                        />
                                        {errors[`designation${idx}`] && (<span className="company-required-content" style={styleError}>
                                            {errors[`designation${idx}`]}
                                        </span>
                                        )}

                                    </div>

                                    <div className='col-xxl-4 col-xl-6 py-3'>

                                        <label className='profile-text'>Email
                                            <span className='text-danger'> *</span>
                                        </label>

                                        <InputField
                                            name="email"
                                            placeholder={"Enter your email"}
                                            className={"input-error-border"}
                                            value={item.email}
                                            onChange={(e) => handleContactInfoChange(e, idx)}
                                            onBlur={(e) => handleFocusOut(e, idx)}
                                            disabled={props.disableProfile || isViewer}
                                            maxLength={150 + 1}
                                            autoComplete="off"
                                        />

                                        {errors[`email${idx}`] && (<span className="company-required-content" style={styleError}>
                                            {errors[`email${idx}`]}
                                        </span>
                                        )}

                                        {allErrors[`phone_and_email${idx}`] && (<span className="company-required-content" style={styleError}>
                                            {allErrors[`phone_and_email${idx}`]}
                                        </span>
                                        )}

                                    </div>

                                    <div className='col-xxl-4 col-xl-6 py-3'>
                                        <label className='profile-text'>Mobile Number
                                            <span className='text-danger'> *</span>
                                        </label>

                                        <PhoneInput
                                            id="contact-form-mobile"
                                            name="phone"
                                            international limitMaxLength
                                            placeholder="Enter your number"
                                            onChange={(e) => handleContactPhoneChange(e, idx)}
                                            value={inputFields[idx]?.phone}
                                            onBlur={(e) => handleFocusOut(e, idx)}
                                            // disabled={props.disableProfile}
                                            className={`${props.disableProfile || isViewer ? `contact-border-remove phone_disable` : ``}`}
                                            autoComplete="off"


                                        />
                                        {errors[`phone${idx}`] && (<span className="company-required-content" style={styleError}>
                                            {errors[`phone${idx}`]}
                                        </span>
                                        )}

                                    </div>

                                    <div className='col-xxl-4 col-xl-6 py-3'>
                                        <div className="row">
                                            <div className='col-xxl-9 col-xl-9 col-md-9'>
                                                <label className='profile-text'> Upload Photo
                                                </label>

                                                <MultiChoosefile
                                                    className={`form-control choose-pdf hide-file-name`}
                                                    type="file"
                                                    accept="image/jpeg, image/png, image/jpg"
                                                    onChange={handleChange2}
                                                    name={`images#@${idx}`}
                                                    id={`images#@${idx}`}
                                                    disabled={props.disableProfile || isViewer}
                                                />

                                                {errors[`images#@${idx}`] && (
                                                    <span className="company-required-content" style={styleError}>{errors[`images#@${idx}`]}</span>
                                                )}
                                                <p className='upload-info'>Allowed JPEG, JPG or PNG. Max size of 2 MB</p>
                                            </div>

                                            <div className='col-xxl-3 col-xl-3 col-md-3'>
                                                <div className='d-flex upload-img contact-upload-image'>
                                                    {existingFiles[`images#@${idx}`] ? (
                                                        // <img src={existingFiles[`images#@${idx}`].path} alt="" className='contactUploadImg' id="pdf-img" onClick={() => handleImageShow(existingFiles[`images#@${idx}`]?.path)}/>
                                                        <img src={existingFiles[`images#@${idx}`].path} alt="" className='contactUploadImg' id="pdf-img0" />
                                                    ) : file[`images#@${idx}`] && file[`images#@${idx}`].path.startsWith("blob:", 1) ? (
                                                        <img src={file[`images#@${idx}`].path} alt='certificate_IMAGE' className='contactUploadImg' id="pdf-img1" />
                                                    ) : (
                                                        <img src={uploadPhotos} alt='certificate_IMAGE' className='contactUploadImg' id="pdf-img2" />
                                                    )}

                                                    {existingFiles[`images#@${idx}`]?.imageId && existingFiles[`images#@${idx}`]?.path.endsWith('.svg') ? (
                                                        <>
                                                        </>
                                                    ) : (
                                                        (!isViewer && !props.disableProfile) && existingFiles[`images#@${idx}`]?.imageId && (
                                                            (existingFiles[`images#@${idx}`]?.path.endsWith('.jpg') ||
                                                                existingFiles[`images#@${idx}`]?.path.endsWith('.jpeg') ||
                                                                existingFiles[`images#@${idx}`]?.path.endsWith('.png')) && (
                                                                <>
                                                                    <button className="pdf-close" type="button" onClick={() => handleRemove(existingFiles[`images#@${idx}`]?.imageId)}>
                                                                        <i className="fa-regular fa-trash-can text-danger"></i>
                                                                    </button>
                                                                </>
                                                            )
                                                        )
                                                    )}

                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                    
                                    {/* <div className='col-xxl-6 col-xl-6'>
                                        <div className='inq-checkbox-container'>
                                            <input type="checkbox" className='mt-0' name="inq_allow" checked={item.inq_allow} disabled={isEmpty(item.email)}  onChange={(e) => handleContactInqEmail(e, idx)}/> 
                                            <label className='ms-2 mb-0'>
                                                Receive inquiry notifications by email
                                            </label>
                                        </div>
                                        
                                    </div> */}
                                    <div className="col-xxl-6 col-xl-6">
                                        <div className="d-flex align-items-center">
                                            <input
                                                type="checkbox"
                                                className="form-check-input mt-0 flex-shrink-0"
                                                name="inq_allow"
                                                checked={item.inq_allow}
                                                disabled={isEmpty(item.email)}
                                                onChange={(e) => handleContactInqEmail(e, idx)}
                                            />
                                            <label className="form-check-label ms-2 mb-0">
                                                Receive inquiry notifications by email
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>

                    {(!props.disableProfile && !isViewer) && (
                            
                        // <div className='mt-5 border-top mx-1'>
                        //     <div className='inq-checkbox-container'>
                        //         <input type="checkbox" name="inqOnRegEmail" checked={inqOnRegEmail} onChange={handleRegEmailChange} disabled={regEmail || props.disableProfile || isViewer}/>
                        //         <label className='mx-2 mb-0'>
                        //             Receive inquiry notifications at the registered email <b>({memberEmail})</b>.
                        //         </label>
                        //     </div>

                        //     <div className='profile-btn'>
                        //         <ButtonAdminpanel className="mt-4 btn-regi" type="submit" disabled={isButtonDisabled || props.disableProfile || isViewer}>
                        //             Save Changes
                        //         </ButtonAdminpanel>
                        //     </div>
                        // </div> 
                        
                        <div className="border-top mt-4 pt-3 d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center">
                                <input
                                    type="checkbox"
                                    className="form-check-input mt-0"
                                    name="inqOnRegEmail"
                                    checked={inqOnRegEmail}
                                    onChange={handleRegEmailChange}
                                    disabled={regEmail || props.disableProfile || isViewer}
                                />

                                <label className="form-check-label ms-2 mb-0">
                                    Receive inquiry notifications at the registered email{" "}
                                    <b>({memberEmail})</b>.
                                </label>
                            </div>

                            <ButtonAdminpanel
                                className="btn-regi"
                                type="submit"
                                disabled={isButtonDisabled || props.disableProfile || isViewer}
                            >
                                Save Changes
                            </ButtonAdminpanel>
                        </div>
                    )}

                </div>

            </form>

            <SmallPopup
                title="Delete Contact"
                smallmodalShow={smallmodalShow}
                setSmallModalShow={setSmallModalShow}
                onSubmit={handleConfirmDeleteClick}
                closeButtonLabel="Cancel"
                okButtonLabel="Delete"
            >
                <div className='row my-3'>
                    <div className="col-md-12 p-0">Are you sure you want to delete?</div>
                </div>
            </SmallPopup>

            <SmallPopup
                title="Delete Image"
                smallmodalShow={smallmodalShow0}
                setSmallModalShow={setSmallModalShow0}
                onSubmit={handleConfirmDeleteClick0}
                closeButtonLabel="Cancel"
                okButtonLabel="Delete"
            >
                <div className='row my-3'>
                    <div className="col-md-12 p-0">Are you sure you want to delete?</div>
                </div>

            </SmallPopup>

            <MediumPopup
                title="Contact Person Image"
                mediummodalShow={mediummodalShow}
                setMediumModalShow={setMediumModalShow}
                closeButtonLabel="Cancel"
            >
                <div className='row my-3'>
                    <div className="col-md-12 p-0">
                        <img src={docImagePath} alt="Placeholder" style={style3} id="pdf-img" />
                    </div>
                </div>

            </MediumPopup>
        </>

    )
}

const mapStateToProps = (state) => {
    return {
        getContact: state.update.getContact,
        updateContact: state.update.updateContact,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getContact: (member_id) => dispatch(getContactAction(member_id)),
        updateContact: (member_id, inputFields, formdata, contact_type, inqOnReg) =>
            dispatch(updateContactAction(member_id, inputFields, formdata, contact_type, inqOnReg)),
        deleteContact: (id) => dispatch(deleteContact(id)),
        deleteContactImage: (id) => dispatch(deleteContactImage(id)),
        showLoading: () => dispatch(showLoading()),
        hideLoading: () => dispatch(hideLoading())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContectInfo);
